var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 39.9999,
    height: 39.9998,
    rx: 19.9999,
    fill: "#FCAB60",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3025 15.9224L19.117 10.2544C19.1989 10.0904 19.3249 9.95243 19.4809 9.856C19.6368 9.75957 19.8166 9.7085 19.9999 9.7085C20.1833 9.7085 20.363 9.75957 20.5189 9.856C20.6749 9.95243 20.8009 10.0904 20.8828 10.2544L23.6973 15.9224L29.9893 16.8368C30.1708 16.8619 30.3416 16.9376 30.4821 17.0552C30.6226 17.1727 30.7273 17.3274 30.7841 17.5016C30.8409 17.6758 30.8476 17.8625 30.8035 18.0403C30.7593 18.2181 30.666 18.3799 30.5342 18.5073L25.9821 22.9164L27.0567 29.1456C27.1943 29.9451 26.3493 30.5539 25.6267 30.1769L19.9999 27.2346L14.372 30.1769C13.6505 30.555 12.8055 29.9451 12.9431 29.1445L14.0177 22.9154L9.46558 18.5062C9.33448 18.3788 9.24176 18.2171 9.19796 18.0396C9.15415 17.8621 9.16102 17.6759 9.21779 17.5021C9.27455 17.3283 9.37893 17.1739 9.51906 17.0565C9.65919 16.9391 9.82946 16.8633 10.0105 16.8379L16.3025 15.9224Z",
    stroke: "#FCAB60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.dfe81d9804bb896e832ac02b28e77c28.svg";
export { ForwardRef as ReactComponent };